module.exports = __webpack_public_path__ + "static/media/menu-dish.19f90e9a.png";